<template>
  <div>
      <mark-test-exam-ai v-if="isTestSpeakingAi" :uuid="uuid"></mark-test-exam-ai>
      <assignment-grading-activities
          v-else-if="hasLoadedSchedule && hasLoadedSpeakingRubricVersion"
          :speaking-rubric-version="speakingRubricVersion"
      ></assignment-grading-activities>
  </div>
</template>

<script>
import MarkTestExamAi from "@/view/pages/test-input/components/MarkTestExamAi";
import AssignmentGradingActivities from "@/view/pages/test-input/components/AssignmentGradingActivities";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {GET_RESULT_EXAM, SHOW_TEST_INPUT_ITEM} from "../../../core/services/store/test/testInput.module";

export default {
  name: "MarkTheExam",
  components: {
    MarkTestExamAi,
    AssignmentGradingActivities
  },
  data() {
    return {
      testInputScheduleItem: [],
      uuid: '',
      speakingRubricVersion: 1,
      hasLoadedSchedule: false,
      hasLoadedSpeakingRubricVersion: false
    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Chi tiết Tác vụ", route: 'task-details'},
      {title: "Chấm bài Test đầu vào"}
    ]);
  },
  mounted() {
    this.getTestInputItem();
    this.getSpeakingRubricVersion();
  },
  computed: {
    isTestSpeakingAi() {
        return this.testInputScheduleItem.sub_type;
    }
  },
  methods: {
    getTestInputItem()
    {
      this.$store.dispatch(SHOW_TEST_INPUT_ITEM, {id: this.$route.params.id}).then((res) => {
        this.testInputScheduleItem = res.data;
        this.uuid = res.data.test_input_schedule.uuid;
      }).finally(() => {
        this.hasLoadedSchedule = true;
      })
    },
    getSpeakingRubricVersion() {
      this.$store.dispatch(GET_RESULT_EXAM, this.$route.params.id).then((res) => {
        if (!res.error) {
          this.speakingRubricVersion = res.data?.speaking_rubric_version ?? 1;
        }
      }).catch(() => {
        this.speakingRubricVersion = 1;
      }).finally(() => {
        this.hasLoadedSpeakingRubricVersion = true;
      })
    },
  }
}
</script>

<style scoped>

</style>
